<template>
  <div
    v-if="animationStyle == 'TrendingAuthorsGrid'"
    class="flex flex-wrap gap-8"
  >
    <div
      v-for="index in 4"
      :key="index"
      class="animate-pulse flex flex-col gap-2 items-center w-16"
    >
      <div class="rounded-full bg-lighter-gray h-16 w-16"></div>
      <div class="w-full h-2 bg-lighter-gray rounded mb-2"></div>
    </div>
  </div>
  <template v-if="animationStyle == 'TrendingAuthorsList'">
    <div
      v-for="index in 4"
      :key="index"
      class="animate-pulse flex space-x-4 mb-4"
    >
      <div class="rounded-full bg-lighter-gray h-16 w-16"></div>
      <div class="flex-1 space-y-6 py-1">
        <div class="h-2 bg-lighter-gray rounded"></div>
        <div class="grid grid-cols-2 gap-4">
          <div class="h-2 bg-lighter-gray rounded col-span-1"></div>
          <div class="h-2 bg-lighter-gray rounded col-span-1"></div>
        </div>
      </div>
    </div>
  </template>
</template>

<script>
export default {
  name: "TrendingAuthorsAnimation",
  props: {
    animationStyle: {
      type: String,
      required: true,
    },
  },
};
</script>
